import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/components/PublicTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToasterProvider"] */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/components/WebVitalsReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/providers/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/providers/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/providers/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/styles/themes.css");
